"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function cov_1vsdzse0i4() {
  var path = "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/resaleAvailability/lib/type.js";
  var hash = "e36c0aaee943885462f14129ef4503413ecbedc8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/resaleAvailability/lib/type.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 31
        },
        end: {
          line: 10,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e36c0aaee943885462f14129ef4503413ecbedc8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vsdzse0i4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1vsdzse0i4();
var ResaleAvailabilityType = (cov_1vsdzse0i4().s[0]++, _propTypes.default.shape({
  isDisplayResaleLink: _propTypes.default.bool,
  resaleProductUrl: _propTypes.default.string,
  resalePassUrl: _propTypes.default.string,
  resalePerformanceUrl: _propTypes.default.string,
  supportedProductTypes: _propTypes.default.array,
  supportedProductFamilySubTypes: _propTypes.default.array
}));
var _default = exports.default = ResaleAvailabilityType;